import { Card, CardContent, Stack, TextField, Typography, Tooltip, IconButton } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

export type LoginIdentifierFieldProps = {
  phone: string
  setPhone?: (value: string) => void
  email: string
  setEmail?: (value: string) => void
  phoneError?: string | undefined
  emailError?: string | undefined
  disabled?: boolean
}

const LoginIdentifierField = ({
  phone,
  setPhone,
  email,
  setEmail,
  phoneError,
  emailError,
  disabled = false,
}: LoginIdentifierFieldProps) => (
  <Card sx={{ backgroundColor: '#f5f5f5', marginTop: 2, marginBottom: 2 }}>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        User Login Identifiers
      </Typography>
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <TextField
            id="phoneLoginIdentifier"
            label="Access Phone Number"
            variant="outlined"
            value={phone}
            onChange={(event) => setPhone && setPhone(event.target.value)}
            error={!!phoneError}
            helperText={phoneError}
            disabled={disabled}
            fullWidth
          />
          <Tooltip title="This phone number creates the user’s account and gives them access to the Field App. Changing or removing it will update or revoke their access.">
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <TextField
            id="emailLoginIdentifier"
            label="Access Email"
            variant="outlined"
            value={email}
            onChange={(event) => setEmail && setEmail(event.target.value)}
            error={!!emailError}
            helperText={emailError}
            disabled={disabled}
            fullWidth
          />
          <Tooltip title="This Email creates the user’s account and gives them access to the EIDU Console. Changing or removing it will update or revoke their access.">
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
)

export default LoginIdentifierField
